import React, { Component } from 'react';
import StackupTable from '@/components/EditableTable';
import { getMaterialTable } from '../../../../../services/Stackup/stackupTableHelper';
import {
    EyeOutlined,
} from '@ant-design/icons';
import MaterialPanel from '@/components/Material';
import './index.css'; // 导入外部样式

const StackupColumns = [
    {
        title: 'Index',
        dataIndex: 'indexStackup',
        key: 'indexStackup',
        width: 70,
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: 150,
    },
    {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        width: 100,
    },
    {
        title: 'Material',
        dataIndex: 'material',
        key: 'material',
        width: 150,
    },
    {
        title: 'Thickness (μm)',
        dataIndex: 'thickness',
        key: 'thickness',
        width: 130,
    },
    {
        title: 'Elevation (μm)',
        dataIndex: 'elevation',
        key: 'elevation',
        width: 130,
    },
    {
        title: 'Connectivity',
        dataIndex: 'info',
        key: 'info',
        width: 200,
    },
];

class OverlapStackup extends Component {
    constructor(props) {
        super(props);
        this.state = { data: null, error: null, scale: 35, columns: [...StackupColumns] };
    }

    componentDidMount() {
        // this.getColumns();
    }

    _saveMaterial = ({ newMaterial, applyAllType, selectMaterialName, record, dataIndex }) => {
        const { designID } = this.props;
        this.props.saveMaterial({ newMaterial, applyAllType, selectMaterialName, record, designID, dataIndex });
    }

    getColumns = () => {
        const { openMaterialMenu, pageType, materialList } = this.props;
        const materialFn = { MaterialPanel, materialList, _saveMaterial: this._saveMaterial };
        StackupColumns.forEach((column) => {
            const { dataIndex } = column;
            switch (dataIndex) {
                case "material":
                    column.onCell = (record) => {
                        return getMaterialTable(record, record.material, materialFn, column.dataIndex, pageType)
                    }

                    column.title = () => {
                        return (
                            <span className="stackup-material-title">
                                Material <EyeOutlined
                                    title="Open material menu"
                                    className='open-material-icon'
                                    onClick={(e) => openMaterialMenu(e)} />
                            </span>
                        );
                    }
                    column.render = (text, record) => {
                        let _text = record.material;
                        if (record.type === "Metal" && record.material) {
                            _text = `${record.material} (σ=${record.Conductivity})`;
                        }
                        if (record.type === 'Dielectric' && record.material) {
                            _text = `${record.material} (εᵣ=${record.Er}, δ=${record.LossTangent})`;
                        }
                        return <span title={_text}>{_text}</span>
                    }
                    break;
                default:
                    break;
            }
        })
    }

    render() {
        const { xmlData } = this.props;
        const { data, error, scale, newInsertIndex, addRowLightClass } = this.state;
        return (
            <div className="stackup-main">
                <div className="stackup-table-section">
                    <StackupTable
                        dataSource={xmlData.allTableLayers}
                        columns={StackupColumns}
                        tableLayout="fixed"
                        rowKey={(record) => record.indexStackup + record.name}
                        size="small"
                        pagination={false}
                        rowClassName={(record, index) => {
                            let className = "stackup-all-layer ";
                            if (record.type === "Dielectric") {
                                if (index === newInsertIndex && addRowLightClass) {
                                    className += "stackup-table-row-light";
                                } else if (index === 0 || index === xmlData.allTableLayers.length - 1) {
                                    className += "stackup-out-dielectric-color";
                                } else {
                                    className += "stackup-in-dielectric-color";
                                }
                            } else {
                                className += "stackup-all-metal-color";
                            }
                            return className;
                        }}
                    />
                </div>
                <div className="stackup-canvas-container">
                    <div
                        className="stackup-canvas"
                        style={{ height: (xmlData.totalDisplayHeight * scale + 100) + "px" }}
                    >
                        <div className="dielectric-column">
                            <div className="column-header">Dielectrics</div>
                            {xmlData.dielectrics.map((d, i) => (
                                <div
                                    key={`diel-${i}`}
                                    className="layer-element dielectric-layer"
                                    style={{
                                        top: ((xmlData.totalDisplayHeight - d.displayTop) * scale + 40) + "px",
                                        height: (d.displayHeight * scale) + "px",
                                        backgroundColor: d.layer.color
                                    }}
                                >
                                    {d.layer.name} ({d.layer.thickness}μm)
                                </div>
                            ))}
                        </div>
                        <div className="metal-column">
                            <div className="column-header">Metals & Vias</div>
                            {xmlData.metals.map((m, i) => (
                                <React.Fragment key={`metal-frag-${i}`}>
                                    <div
                                        className="layer-element metal-layer"
                                        style={{
                                            top: ((xmlData.totalDisplayHeight - m.displayTop) * scale + 40) + "px",
                                            height: (Math.max(m.displayHeight * scale, 1)) + "px",
                                            backgroundColor: m.layer.color
                                        }}
                                    />
                                    <div
                                        className="metal-label"
                                        style={{
                                            top: ((xmlData.totalDisplayHeight - m.displayTop) * scale + 40) + "px",
                                            height: (Math.max(m.displayHeight * scale, 1)) + "px"
                                        }}
                                    >
                                        {m.layer.name} ({m.layer.thickness}μm)
                                    </div>
                                </React.Fragment>
                            ))}

                            {xmlData.viaGroups.map((group, gIdx) =>
                                group.map((v, i) => {
                                    const hPos = 110 + (gIdx * 55);
                                    return (
                                        <div
                                            key={`via-${gIdx}-${i}`}
                                            className="via-element"
                                            style={{
                                                top: ((xmlData.totalDisplayHeight - v.displayTop) * scale + 40) + "px",
                                                height: (Math.max(v.displayHeight * scale, 18)) + "px",
                                                left: hPos + "px",
                                                backgroundColor: v.via.color
                                            }}
                                        >
                                            <span className="via-label">{v.via.name} ({v.realThickness}μm)</span>
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OverlapStackup;